<div><router-outlet></router-outlet></div>
<app-cookie-policy></app-cookie-policy>